const BASE = 'app :';

export const appActionTypes = {
  switchLocale: `${BASE} switch locale`,
  setSerivceRegions: `${BASE} set service regions`,
};

export const setServiceRegions = (serviceRegions) => (dispatch) => {
  dispatch({
    type: appActionTypes.setSerivceRegions,
    serviceRegions,
  });
};

export const switchLocale = (locale) => async (dispatch) => {
  const messages = await import(`../../../locale/${locale}.js` /* webpackChunkName:"locale" */);
  dispatch({
    type: appActionTypes.switchLocale,
    locale,
    messages: messages.default,
  });
};
